import React, { useEffect, useState } from 'react'
import { Translate } from '../../../language'
import Button from '../Button/Button'
import style from './CardInventory.module.css'

const CardInventory = ({ text, onClick, iconClass='', iconClassHover='', Icon, hasOnClick = false }) => {

  const [isHover, setIsHover] = useState(false);
  const [auxIconClass, setAuxIconClass] = useState(iconClass);
  useEffect(() => {
    if(isHover&&iconClass){
      setAuxIconClass(iconClassHover)
    }
    else if(!isHover&&iconClass){
      setAuxIconClass(iconClass)
    }
  }, [isHover]);


  return (
    <div className={style.content_card_oil}
      onMouseLeave={() => setIsHover(false)}
      onMouseEnter={() => setIsHover(true)}>



      <div className={style.content_img_card_oil} onClick={onClick}>
        <Icon className={`${style.img_card_oil} ${auxIconClass}`} />
      </div>

      <div className={style.content_name_card_oil} onClick={onClick}>
        <div className={`${isHover?`${style.text_card_oil_hover}`:''}  ${style.text_card_oil}`}>
          {text}
        </div>
      </div>
    </div>
  )
}



export default CardInventory